<template>
  <v-container fluid>
    <v-card class="ma-2 white rounded-lg">
      <v-card-title class="secondary--text">سابقه فعالیت‌های ادمین</v-card-title>

      <v-card-text>
        <m-datatable
          :show-select="false"
          :show-filter-row="false"
          :headers="headers"
          :apiUrl="url"
          :filters.sync="filters"
          ref="datatable"
        >
          <template #item.detail="{ item }">
            <v-tooltip bottom color="info">
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" color="white" icon @click="openPayloadDialog(item)">
                  <v-img max-width="20" max-height="20" src="/img/icons/info_circle.svg"></v-img>
                </v-btn>
              </template>
              مشاهده جزئیات
            </v-tooltip>
          </template>

          <template #item.admin_name="{ item }">
            {{ item.admin_name || '---' }}
          </template>

          <template #item.method="{ item }">
            <v-chip color="primary" dark>{{ item.method }}</v-chip>
          </template>

        </m-datatable>
      </v-card-text>
    </v-card>

    <v-dialog v-model="payloadDialog" max-width="700px">
      <v-card>
        <v-card-title class="headline">جزئیات اکشن ادمین</v-card-title>

        <v-card-text>
          <v-row>
    
            <v-col cols="12" v-if="selectedPayload">
              <h4 class="subtitle-1 font-weight-bold mb-2">جزئیات</h4>
              <pre>{{ selectedPayload }}</pre>
            </v-col>

          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="payloadDialog = false">بستن</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "AdminActionLogPage",
  data() {
    return {
      url: "sobhanAdmin/action-logs/",
      filters: {},
      payload: {},
      payloadDialog: false,
      selectedPayload: null,
    };
  },
  computed: {
    headers() {
      return [
        { 
          text: "ادمین",
          value: "admin_name"
        },
        {
          text: "تاریخ",
          value: "created_at",
          getValue: (item) => {
            return item.created_at.split(" ")[0];
          },
        },
        {
          text: "ساعت",
          value: "date",
          filterable: false,
          sortable: false,
          getValue: (item) => {
            return item.created_at.split(" ")[1];
          },
        },
        { 
          text: "روش HTTP",
          value: "method"
        },
        { 
          text: "مسیر",
          value: "path"
        },
        { 
          text: "جزئیات",
          value: "detail",
          sortable: false,
          filterable: false
        },
      ];
    },
  },
  methods: {
    openPayloadDialog(item) {
      if (item.payload) {
        this.selectedPayload = item.payload;
        this.payloadDialog = true;
      }
    },
  },
};
</script>

<style scoped>
pre {
  background-color: #f5f5f5;
  padding: 10px;
  border-radius: 4px;
  overflow-x: auto;
}
</style>
